<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y1Bv4C/tc-custom/9781466860834.jpg?1719574041627" alt="This image is the cover for the book Travel Guide to Europe, 1492"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Travel Guide to Europe, 1492
      </h1>
      <p class="bookDescription body article font2">
        <p>On the eve of the five hundredth anniversary of the discovery of the Americas, it bears remembering that in 1492, as Columbus was making his historic voyage, Europe was flourishing, at the very height of the Renaissance that transformed a continent. In art, politics, commerce, and society, the medieval world had given way to the modern era. <br/><br/>But what was Europe really like then? What did London, Paris, Rome, and the other great centers of culture actually look like, and what was it like to travel from one to the other when the horse and the sailing ship were the most expeditious means available? How long would a typical journey take? Where would one stay and what could one eat along the way? And whom might one expect to meet? Both kings and pilgrims, to be sure.<br/><br/>In <i>Travel Guide to Europe 1492</i>, the noted Italian historian Lorenzo Camusso offers modern-day readers and would-be adventurers ten itineraries for trips commonly taken in both the near and far reaches of fifteenth-century Europe. Whether Camusso's wayfarer is an ambitious young banker on the road From Florence to Bruges;the great painter Albrecht Rurer on his way from Nurember to Venice, a shipbuilder whose highly prized craft takes him from Seville to Antwerp via Barcelona, Beaune, and Paris; or a lonely pilgrim wandering from Vezelay to far-off Santiago de Compostela, he offers a vivid account of what such a journey would be like--the sights, sounds, perils, and pleasures--and in so doing he renders the very fabric of day-to-day life during this momentous ear in Europe's history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lorenzo Camusso
      </h2>
      
      <p class="authorDescription body article"><P>Lorenzo Camusso was born in Montevarchi, Italy, in 1923. For many years he was the editorial director in charge of illustrated books for one of Italy's largest publishing companies.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55dcf0c3